import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';

export function computeCapacitorLimitMultipliers(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue, r5IdealValue) {
  let maxMultiplier = computeCapacitorMaximumLimitMultiplier(
    c1IdealValue,
    c2IdealValue,
    r1IdealValue,
    r2IdealValue,
    r5IdealValue,
  );
  let minMultiplier = computeCapacitorMinimumLimitMultiplier(
    c1IdealValue,
    c2IdealValue,
    r1IdealValue,
    r2IdealValue,
    r5IdealValue,
  );
  return {
    capacitorMinimumLimitMultiplier: minMultiplier,
    capacitorMaximumLimitMultiplier: maxMultiplier,
  };
}

function computeCapacitorMaximumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue, r5IdealValue) {
  var cmax = Math.max(c1IdealValue, c2IdealValue);
  var result = FilterConstants.Limits.CBIG_COMP_LIMIT / cmax;
  var r1Tiny = r1IdealValue / result;
  var r2Tiny = r2IdealValue / result;
  var r5Tiny = r5IdealValue / result;

  if (
    CommonUtils.parallel(r2Tiny, r5Tiny) < FilterConstants.Limits.RSMALL_LOAD_LIMIT ||
    r1Tiny < FilterConstants.Limits.RSMALL_LOAD_LIMIT
  ) {
    const r1LoadRatio = r1Tiny / FilterConstants.Limits.RSMALL_LOAD_LIMIT;
    const r2ParallelR5LoadRatio = CommonUtils.parallel(r2Tiny, r5Tiny) / FilterConstants.Limits.RSMALL_LOAD_LIMIT;
    const resLoadModifier = Math.min(r1LoadRatio, r2ParallelR5LoadRatio, 1);
    result = result * resLoadModifier;
  }

  return result;
}

function computeCapacitorMinimumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue, r5IdealValue) {
  var cmin = Math.min(c1IdealValue, c2IdealValue);
  var result = FilterConstants.Limits.CSMALL_COMP_LIMIT / cmin;
  var r1Big = r1IdealValue / result;
  var r2Big = r2IdealValue / result;
  var r5Big = r5IdealValue / result;

  var biggestR = Math.max(r1Big, r2Big, r5Big);
  if (biggestR > FilterConstants.Limits.RBIG_COMP_LIMIT) {
    result = (result * biggestR) / FilterConstants.Limits.RBIG_COMP_LIMIT;
  }

  return result;
}
